import React, { useState } from "react";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CashierPaymentMobile from "./CashierPaymentMobile";
import CashierSummaryMobile from "./CashierSummaryMobile";
import CashierContentMobile from "./CashierContentMobile";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
import PlacedOrderMobile from "../../../../features/mobile/cashier/PlacedOrderMobile";
import { useSelector, useDispatch } from "react-redux";
import Badge from "@mui/material/Badge";

function CashierFooterMobile() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [value, setValue] = React.useState(0);
  const cartItems = useSelector((state) => state.cashierCart.items);
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  const [selectedOrderCode, setSelectedOrderCode] = useState(null);

  console.log("sel selectedOrderCode", selectedOrderCode);

  const navigateToContent = () => {
    setValue(0); // Set value to 0 to display CashierContentMobile
  };

  const navigateToSummary = (orderCode) => {
    setSelectedOrderCode(orderCode); // Store the order code
    setValue(1); // Navigate to CashierSummaryMobile
  };

  const handleNavigation = (newValue) => {
    setValue(newValue);
  };
  return (
    <Box
      sx={{
        width: "100%",
        // height: "100%",
        backgroundColor: theme.palette.background.paper,
        position: "fixed",
        bottom: 0,
      }}
    >
      <div style={{ flex: 1, overflow: "auto" }}>
        {value === 0 && <CashierContentMobile />}
        {value === 1 && (
          <CashierSummaryMobile
            onNewOrder={navigateToContent}
            orderCode={selectedOrderCode}
            onMoreClick={() => setValue(2)}
          />
        )}
        {value === 2 && <CashierPaymentMobile />}
        {value === 3 && (
          <PlacedOrderMobile
            onPayNow={navigateToSummary}
            onPlacedOrder={navigateToContent}
          />
        )}
      </div>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => handleNavigation(newValue)}
        sx={{
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <BottomNavigationAction
          //  label="Cashier"
          icon={<PointOfSaleIcon />}
        />
        <BottomNavigationAction
          // label="Cart"
          icon={
            <Badge badgeContent={totalItems} color="error">
              <AddShoppingCartIcon />
            </Badge>
          }
        />
        <BottomNavigationAction
          //  label="Payment"
          icon={<LocalAtmIcon />}
        />
        <BottomNavigationAction
          // label="Placed Orders"
          icon={<LocalShippingIcon />}
        />
      </BottomNavigation>
    </Box>
  );
}

export default CashierFooterMobile;
